export const DDC_VIDEO_MILESTONE = 'ddc.video.milestone';
export const VIDEO_PLAY_MILESTONE = 'video-play-milestone';

function milestonesReport(videoMilestone = '', element) {
	const fileType = element.currentSrc?.split('.')?.pop() || '';
	const autoplay = !!element.hasAttribute?.('autoplay');

	return {
		eventType: DDC_VIDEO_MILESTONE,
		eventData: {
			autoplay,
			element,
			videoSource: element.currentSrc,
			videoDuration: element.duration,
			videoMilestone,
			fileType
		},
		overrides: {
			eventType: VIDEO_PLAY_MILESTONE
		}
	};
}

export default milestonesReport;
